import { ref } from "vue";
import api from "@/composables/api";
import { getQueryParameter } from "@/utils";

const ERROR_MESSAGE = "An error occurred, please contact support";
const SUCCESS_MESSAGE = "Success!";

export default function useSquare() {
  const loading = ref(true);
  const response = ref();
  const error = ref();

  const connect = () => {
    connectAPI(getCodeFromUrl());
  };

  const connectAPI = (authCode) => {
    handleResponse(connectApiRaw(authCode));
  };

  const connectApiRaw = (authCode) => {
    return api("v1/square/connect", {
      method: "POST",
      body: {
        authCode,
      },
    });
  };

  const handleResponse = (promise) => {
    promise
      .then(stopLoading)
      .then(handleSuccessResponse)
      .catch(handleErrorResponse);
  };

  const stopLoading = (res) => {
    loading.value = false;
    return res;
  };

  const handleSuccessResponse = (res) => {
    if (res.status === 200) {
      response.value = SUCCESS_MESSAGE;
    } else {
      error.value = ERROR_MESSAGE;
    }
    return res;
  };

  const handleErrorResponse = (err) => {
    loading.value = false;
    error.value = ERROR_MESSAGE;
  };

  const getCodeFromUrl = () => {
    return getQueryParameter("code");
  };

  const getOAuthUrl = () => {
    api("v1/square/uri")
      .then(handleOAuthSuccess);
  };

  const handleOAuthSuccess = (res) => {
    if (res.status === 200) {
      const { authUrl } = res.data;
      window.open(authUrl);
    }
  };

  const disconnect = () => {
    api("v1/square/disconnect", {
      method: "POST",
    });
  };

  return {
    loading,
    error,
    response,
    connect,
    getOAuthUrl,
    disconnect,
  };
}
